<template>
  <div>
    <v-data-table
      :headers="headers"
      :hide-default-footer="showMore"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />

            <td class="nowrap">
              {{
                item.created_at
                  | moment(
                    'timezone',
                    currentUser.active_project.timezone,
                    'MM/DD/YY h:mm A'
                  )
              }}
            </td>
            <td>
              <router-link :to="`/users/participants/${item.user.id}`">
                {{ item.user.full_name }}
              </router-link>
            </td>
            <td>
              {{ item.body }}
            </td>
            <td class="text-center nowrap">
              <Actions
                hide-edit
                hide-show
                hide-duplicate
                :path="`/chats/${entity.id}/messages/${item.id}`"
                @destroy="$emit('destroy', item)"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <router-link v-if="showMore" :to="`/chats/${entity.id}`" class="view-all">
      View All Messages
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    showMore: Boolean,
    entity: Object,
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Date',
          align: 'start',
          value: 'created_at',
          sortable: true,
        },
        {
          text: 'User',
          align: 'start',
          value: 'user',
          sortable: false,
        },
        {
          text: 'Comment',
          align: 'start',
          value: 'body',
          sortable: false,
        },
        {
          text: '',
          align: 'center',
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style></style>
